
export const shouldBeModal = (location) => {
    return !!/\/new-camp\/?/.exec(location.pathname)
        || !!/\/search\/?/.exec(location.pathname)
        || !!/\/workshops\/.+/.exec(location.pathname)
        || !!/\/questions\/.+/.exec(location.pathname)
}

export const isModalChild = (currentLocation, nextLocation) => {
    if( !currentLocation || !nextLocation ) return false;
    if( currentLocation.key === nextLocation.key ) return false;
    return shouldBeModal(currentLocation) || shouldBeModal(nextLocation);
}


// WEBPACK FOOTER //
// ./src/js/services/url-analysis.js